export interface AppConfig {
    FRUITFUL_ENV: string;
    API_URL: string;
    STYTCH_PUBLIC_TOKEN: string;
    STYTCH_ORGANIZATION_ID: string;
    SENDBIRD_APP_ID: string;
    SENTRY_DSN?: string;
    MIXPANEL_TOKEN?: string;
    INACTIVITY_DURATION?: number;
    LLM_SERVICE_BASE_URL: string;

    // TODO do we need to delete these?
    DEV_OVERRIDE_ADMIN_USER_GUIDE_ID?: string;
    DEV_OVERRIDE_ADMIN_USER_ROLE?: string;
}

// Load the appropriate environment file.
// Must use if statements over switch statement in order to ensure that ONLY the desired environment file is included in the bundle.
let config: AppConfig;
if (process.env.EXPO_PUBLIC_FRUITFUL_ENV === 'production') {
    config = require('./production').config as AppConfig;
} else if (process.env.EXPO_PUBLIC_FRUITFUL_ENV === 'staging') {
    config = require('./staging').config as AppConfig;
} else if (process.env.EXPO_PUBLIC_FRUITFUL_ENV === 'sandbox') {
    config = require('./sandbox').config as AppConfig;
} else {
    config = require('./development').config as AppConfig;
}

export const {
    FRUITFUL_ENV,
    API_URL,
    STYTCH_PUBLIC_TOKEN,
    STYTCH_ORGANIZATION_ID,
    SENDBIRD_APP_ID,
    SENTRY_DSN,
    MIXPANEL_TOKEN,
    INACTIVITY_DURATION,
    LLM_SERVICE_BASE_URL,
    DEV_OVERRIDE_ADMIN_USER_GUIDE_ID,
    DEV_OVERRIDE_ADMIN_USER_ROLE,
} = config;
